import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import React, { useEffect, useRef, useState } from 'react';
import { getTopUsers, getTopUsersFilters, search } from "../api/requests";
import ErrorModal from "../components/modals/ErrorModal";
import Footer from "../components/footer/Footer";
import Head from "next/head";
import Layout from "../components/sidebarPro";
import Link from "next/link";
import Pagination from "../components/pagination";
import TableSkeleton from "../components/home/table/TableSkeleton";
import { kFormatter } from "../utils";
import { scrollTop } from '../components/backToTop/services';
import styles from "../assets/css/topUsers.module.scss";
import { useRouter } from "next/router";
import useTranslation from 'next-translate/useTranslation';

var TopUsers = function TopUsers() {
  // console.log("props: ",props);
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  var router = useRouter();

  var _useState = useState(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var toggle = function toggle(item) {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };

  var _useState2 = useState(false),
      forceSelect = _useState2[0],
      setForceSelect = _useState2[1];

  var _useState3 = useState(null),
      selectedItem = _useState3[0],
      setSelectedItem = _useState3[1];

  var _useState4 = useState(null),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState(null),
      filters = _useState5[0],
      setFilters = _useState5[1];

  var _useState6 = useState(false),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(''),
      searchUsers = _useState7[0],
      setSearchUsers = _useState7[1];

  var _useState8 = useState(false),
      showDropDown = _useState8[0],
      setShowDropDown = _useState8[1];

  var inputRef = useRef(null);
  useEffect(function () {
    setLoading(true);
    getTopUsersFilters(isRTL).then(function (res) {
      setFilters(res.data);
    })["catch"](function (err) {
      return console.log(err);
    });
    document.addEventListener('click', function (event) {
      return handleOutsideClick(event, inputRef, setShowDropDown);
    });
    return function () {
      document.addEventListener('click', function (event) {
        return handleOutsideClick(event, inputRef, setShowDropDown);
      });
    };
  }, [isRTL]);
  useEffect(function () {
    if (filters) {
      var defaultSelect = filters.filter(function (item) {
        return item.Id === 2;
      });

      if (defaultSelect.length > 0) {
        setSelectedItem(defaultSelect[0]);
        handleSelect(defaultSelect[0]);
        getTopUsers(defaultSelect[0].Id, 0).then(function (res) {
          var _res$data, _res$data2, _res$data2$Pagination;

          setLoading(false);
          setFilteredData((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.Users);
          setTotalItems((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$Pagination = _res$data2.Pagination) === null || _res$data2$Pagination === void 0 ? void 0 : _res$data2$Pagination.TotalPages);
        })["catch"](function (err) {
          return console.log(err);
        });
      }
    }
  }, [filters]);

  var _useState9 = useState({
    search: ""
  }),
      input = _useState9[0],
      setInput = _useState9[1];

  var handleOutsideClick = function handleOutsideClick(event, inputRef, setShowDropDown) {
    if (inputRef && inputRef.current && !inputRef.current.contains(event.target)) {
      setShowDropDown(false);
    }
  };

  var handleSelect = function handleSelect(selected) {
    setLoading(true);
    setSelectedItem({
      title: selected.Title,
      count: selected.Count,
      id: selected.Id
    });
    setActivePage(0);
    setForceSelect(!forceSelect);
    getTopUsers(selected.Id, 0).then(function (res) {
      var _res$data3, _res$data4, _res$data4$Pagination;

      setLoading(false);
      setFilteredData((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.Users);
      setTotalItems((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$Pagination = _res$data4.Pagination) === null || _res$data4$Pagination === void 0 ? void 0 : _res$data4$Pagination.TotalPages);
    })["catch"](function (err) {
      return console.log(err);
    });
  };

  var handleChange = function handleChange(_ref) {
    var _ref$target = _ref.target,
        name = _ref$target.name,
        value = _ref$target.value;
    setInput(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, value));
    });
    setSearchUsers(''); // handleSearch();
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  var handleSearch = function handleSearch() {
    setShowDropDown(true);
    search(input.search).then(function (res) {
      var _res$data$Pagination;

      // console.log("search res", res.data)
      if (((_res$data$Pagination = res.data.Pagination) === null || _res$data$Pagination === void 0 ? void 0 : _res$data$Pagination.Total) === 0) {
        setError(["search", false]);
        setShow(true);
      } else {
        setSearchUsers(res.data.Users); // router.push({
        //     pathname: `/profile/${res.data.Counter}`,
        //     query: {name: res.data.Name + " " + res.data.Family}
        // })
      }
    })["catch"](function (err) {
      console.log(err);
    });
  };

  var getProfileImageSrc = function getProfileImageSrc(item) {
    if (item && item.ProfileImage && item.ProfileImage === 'img/head.png') {
      return '/images/table/profile.png';
    } else if (item && item.ProfileImage && item.ProfileImage !== " ") {
      return item.ProfileImage;
    } else {
      return '/images/table/profile.png';
    }
  };

  var _useState10 = useState(null),
      error = _useState10[0],
      setError = _useState10[1];

  var _useState11 = useState(false),
      show = _useState11[0],
      setShow = _useState11[1];

  var toggleModal = function toggleModal() {
    return setShow(!show);
  };

  var _useState12 = useState(null),
      totalItems = _useState12[0],
      setTotalItems = _useState12[1];

  var _useState13 = useState(0),
      activePage = _useState13[0],
      setActivePage = _useState13[1];

  var _useState14 = useState([]),
      filteredData = _useState14[0],
      setFilteredData = _useState14[1];

  var handlePageClick = function handlePageClick(selectedPage) {
    setActivePage(selectedPage);
    selectedPage = selectedPage + 1;

    if (selectedPage === 1) {
      selectedPage = null;
    }

    getTopUsers(selectedItem.id, selectedPage).then(function (res) {
      var _res$data5, _res$data6, _res$data6$Pagination;

      setLoading(false);
      setFilteredData((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.Users);
      setTotalItems((_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : (_res$data6$Pagination = _res$data6.Pagination) === null || _res$data6$Pagination === void 0 ? void 0 : _res$data6$Pagination.TotalPages);
    })["catch"](function (err) {
      return console.log(err);
    });
    scrollTop();
  };

  return /*#__PURE__*/_jsxs(Layout, {
    page: "top-users",
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: isRTL ? "کاربران برتر - دنیای واژگان" : "Top Users - wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx(ErrorModal, {
      error: error,
      show: show,
      toggle: toggleModal
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-5 ".concat(styles.topUserWrapper),
      children: [/*#__PURE__*/_jsx("h3", {
        className: styles.title,
        children: t('topUsers:top-users')
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.topHolder,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "".concat(styles.form, " form-control d-flex"),
          ref: inputRef,
          children: [/*#__PURE__*/_jsx("img", {
            onClick: handleSearch,
            src: "/images/topUsers/search.svg"
          }), /*#__PURE__*/_jsx("input", {
            placeholder: isRTL ? 'جستجو کاربر' : 'Search User',
            onChange: handleChange,
            value: input.search,
            name: "search",
            onKeyDown: handleKeyDown,
            style: {
              fontFamily: isRTL ? 'Yekan' : 'Helvetica'
            }
          }), /*#__PURE__*/_jsx("div", {
            className: styles.searchResultsWrapper,
            children: showDropDown && searchUsers !== '' && searchUsers.map(function (item, index) {
              return /*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: "/profile/".concat(item.Counter),
                  query: {
                    name: item.FullName
                  }
                },
                children: /*#__PURE__*/_jsxs("a", {
                  className: styles.searchResult,
                  children: [/*#__PURE__*/_jsxs("p", {
                    children: ["Name: ", item.FullName]
                  }), /*#__PURE__*/_jsx("img", {
                    className: "".concat(styles.icon2),
                    src: getProfileImageSrc(item)
                  })]
                })
              });
            })
          })]
        }), filteredData && /*#__PURE__*/_jsxs(Dropdown, {
          className: isRTL ? styles.dropDownFa : styles.dropDownEng,
          isOpen: dropdownOpen,
          toggle: toggle,
          children: [/*#__PURE__*/_jsxs(DropdownToggle, {
            caret: true,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.medals,
              children: [/*#__PURE__*/_jsx("img", {
                src: "images/table/bronzeBadge.svg"
              }), /*#__PURE__*/_jsx("img", {
                src: "images/table/silverBadge.svg"
              }), /*#__PURE__*/_jsx("img", {
                src: "images/table/goldBadge.svg"
              })]
            }), /*#__PURE__*/_jsx("span", {
              children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title
            }), " ", /*#__PURE__*/_jsx("span", {
              children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.count
            }), /*#__PURE__*/_jsx("img", {
              className: styles.arrowDown,
              src: "images/table/arrowDown.svg"
            })]
          }), /*#__PURE__*/_jsx(DropdownMenu, {
            children: filteredData && filters && filters.map(function (item) {
              return /*#__PURE__*/_jsxs(DropdownItem, {
                onClick: function onClick() {
                  return handleSelect(item);
                },
                children: [item.Title, " ", ' : ', " ", kFormatter(item.Count)]
              }, item.Id);
            })
          })]
        })]
      }), loading && /*#__PURE__*/_jsx(TableSkeleton, {}), !loading && filteredData && /*#__PURE__*/_jsx("div", {
        className: styles.tableWrapper,
        children: /*#__PURE__*/_jsxs("table", {
          className: "table mt-4 ".concat(styles.table, " ").concat(isRTL ? styles.tableFa : ''),
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              className: styles.borderNone,
              children: [/*#__PURE__*/_jsxs("th", {
                className: styles.header,
                scope: "col",
                children: ["#", /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('topUsers:name'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('topUsers:score'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('topUsers:grade'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('topUsers:words'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                className: "".concat(styles.desktopOnlyColumn, " ").concat(styles.daysPlayed),
                scope: "col",
                children: [t('topUsers:days-played'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                className: "".concat(styles.desktopOnlyColumn),
                scope: "col",
                children: [t('topUsers:city'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                className: "".concat(styles.desktopOnlyColumn),
                scope: "col",
                children: [t('topUsers:awards'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: filteredData && filteredData.map(function (item, index) {
              var _item$ContestProfile, _item$ContestProfile2, _item$ContestProfile3, _item$ContestProfile4, _item$ContestProfile5, _item$ContestProfile6, _item$ContestProfile7, _item$ContestProfile8, _item$ContestProfile9;

              return /*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: "/profile/".concat(item.Counter),
                  query: {
                    name: item.FullName
                  }
                },
                children: /*#__PURE__*/_jsxs("tr", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("th", {
                    className: styles.index,
                    scope: "row",
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "btn d-flex justify-content-around align-items-center",
                      children: [/*#__PURE__*/_jsxs("span", {
                        children: [activePage * 10 + index + 1, '.', " "]
                      }), /*#__PURE__*/_jsx("img", {
                        className: "".concat(styles.icon),
                        src: getProfileImageSrc(item)
                      })]
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: item.FullName
                  }), /*#__PURE__*/_jsx("td", {
                    children: kFormatter((_item$ContestProfile = item.ContestProfile) === null || _item$ContestProfile === void 0 ? void 0 : _item$ContestProfile.TotalReputation)
                  }), /*#__PURE__*/_jsx("td", {
                    children: (_item$ContestProfile2 = item.ContestProfile) !== null && _item$ContestProfile2 !== void 0 && _item$ContestProfile2.MappedGroupCode ? ((_item$ContestProfile3 = item.ContestProfile) === null || _item$ContestProfile3 === void 0 ? void 0 : _item$ContestProfile3.MappedGroupCode) + 'th' : '-'
                  }), /*#__PURE__*/_jsx("td", {
                    children: (_item$ContestProfile4 = item.ContestProfile) === null || _item$ContestProfile4 === void 0 ? void 0 : _item$ContestProfile4.WoW
                  }), /*#__PURE__*/_jsx("td", {
                    className: "".concat(styles.desktopOnlyColumn),
                    children: (_item$ContestProfile5 = item.ContestProfile) === null || _item$ContestProfile5 === void 0 ? void 0 : _item$ContestProfile5.DaysPlayed
                  }), /*#__PURE__*/_jsx("td", {
                    className: "".concat(styles.desktopOnlyColumn),
                    children: item.State
                  }), /*#__PURE__*/_jsx("td", {
                    className: "".concat(styles.desktopOnlyColumn),
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "d-flex justify-content-around",
                      children: [/*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/bronzeBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile6 = item.ContestProfile) === null || _item$ContestProfile6 === void 0 ? void 0 : _item$ContestProfile6.TotalBronzeBadges
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/silverBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile7 = item.ContestProfile) === null || _item$ContestProfile7 === void 0 ? void 0 : _item$ContestProfile7.TotalSilverBadges
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/goldBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile8 = item.ContestProfile) === null || _item$ContestProfile8 === void 0 ? void 0 : _item$ContestProfile8.TotalGoldBadges
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/diamondBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile9 = item.ContestProfile) === null || _item$ContestProfile9 === void 0 ? void 0 : _item$ContestProfile9.DiamondBadges
                        })]
                      })]
                    })
                  })]
                }, index)
              });
            })
          })]
        })
      }), filteredData && totalItems && /*#__PURE__*/_jsx(Pagination, {
        previousLabel: function previousLabel() {
          return 'prev';
        },
        forceDisplay: true,
        nextLabel: function nextLabel() {
          return 'next';
        },
        pageCount: totalItems,
        initialPage: 1,
        onPageChange: handlePageClick,
        activePage: activePage,
        googlePaginate: true,
        forceSelect: forceSelect
      })]
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export var __N_SSG = true;
export default TopUsers;